import { useState } from 'react';
import { Flag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ReportContentDialog } from '@/components/ReportContentDialog';

type ContentType = 'review' | 'review_comment' | 'activity_comment' | 'message' | 'tag' | 'author_bio';

interface ReportButtonProps {
  contentType: ContentType;
  contentId: string;
  contentPreview?: string;
  variant?: 'ghost' | 'outline' | 'default';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
}

export function ReportButton({
  contentType,
  contentId,
  contentPreview,
  variant = 'ghost',
  size = 'sm',
  className,
}: ReportButtonProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={(e) => {
          e.stopPropagation();
          setIsDialogOpen(true);
        }}
        className={className}
        title="Report this content"
      >
        <Flag className="h-4 w-4" />
        <span className="ml-2">Report</span>
      </Button>

      <ReportContentDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        contentType={contentType}
        contentId={contentId}
        contentPreview={contentPreview}
      />
    </>
  );
}
